const ErrorNotFound = () => {

	return (
		<>
			<h1 className="text-align--center">ERROR NOT FOUND</h1>
		</>
	)
}

export default ErrorNotFound